import image1 from '@/assets/images/news/detail/20200929/1.jpg';
import image2 from '@/assets/images/news/detail/20200929/2.jpg';
import image3 from '@/assets/images/news/detail/20200929/3.jpg';
import image4 from '@/assets/images/news/detail/20200929/4.jpg';
import image5 from '@/assets/images/news/detail/20200929/5.jpg';
import image6 from '@/assets/images/news/detail/20200929/6.jpg';
import image7 from '@/assets/images/news/detail/20200929/7.jpg';
import image8 from '@/assets/images/news/detail/20200929/8.jpg';
import image9 from '@/assets/images/news/detail/20200929/9.jpg';

export default {
  id: '20200929', //  模块 id
  title: '笔墨书团圆 才情话佳节 | 中秋活动精彩回顾', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text: '中秋传统佳节',
      isIndent: false,
    },
    {
      type: 0,
      text: '叮咚买菜的伙伴们',
      isIndent: false,
    },
    {
      type: 0,
      text: '用一场特别的方式传寄祝福',
      isIndent: false,
    },
    {
      type: 0,
      text: '快来和小编一起来看看吧',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '实力派',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: '创意派',
      isIndent: false,
    },
    {
      type: 0,
      text: '没有想到，叮咚里藏着这么多高手',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text: '最淳朴的祝福，寄托最真实的心声',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text: '这只可爱的小白兔，请问您是哪个部门的？',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text: '别有风“味”的祝福，还有最最实在的期待。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text:
        '来到叮咚，小家变大家。“家”的力量支撑着我们前行，想念家人，想念一起奋战的兄弟们，无论你身处何方，我们与你同在。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 0,
      text:
        '我们对于服务与品质的坚守，是获取用户信任的根本，带着这份信任我们砥砺前行，未来我们一起“月”来“月”好。（立个小“flag”吧！）',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 0,
      text: '人在江湖，廉洁诚信为先',
      isIndent: false,
    },
    {
      type: 0,
      text: '颁奖时刻',
      isIndent: false,
    },
    {
      type: 0,
      text: '恭喜书法活动中人气投票最高的5位小伙伴！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image9],
    },
    {
      type: 0,
      text:
        '同时，恭喜线上“Pick五仁君C位出道”活动中排名前30的小伙伴。成功的路上不一定都是一帆风顺，只要我们坚定目标，坚持下去，成功就在不远处。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '前进路上，有才情有梦想的叮咚人，将继续用自己的踏实与奋斗，践行叮咚最朴实的承诺。感谢金主爸爸采销部门提供的精美礼品 ',
      isIndent: false,
    },
  ],
};
